import type { EntityState } from '@reduxjs/toolkit';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { createComparer } from '../../../utils/object/object';
import { getItems } from '../../actions/api/items';
import { setMarket } from '../intl';
import { mergeStateReducerBuilder } from '../../reducers/generic/mergeState';
import type { ItemDTO } from '../../mappers/dtoMappers';

const itemEntityAdapter = createEntityAdapter<ItemDTO, string>({
  selectId: (item) => item.itemNo,
  sortComparer: createComparer('itemNameOfficial'),
});

const itemSlice = createSlice({
  name: 'item',
  initialState: itemEntityAdapter.getInitialState(),
  extraReducers: (builder) =>
    mergeStateReducerBuilder('state.item', builder)
      .addCase(setMarket, () => itemEntityAdapter.getInitialState())
      .addCase(getItems.fulfilled, (state, action) => {
        const {
          items,
          meta: { totalNumberOfElements },
        } = action.payload;
        if (typeof totalNumberOfElements === 'number') {
          itemEntityAdapter.setMany(state, items);
        }
      }),
  reducers: {},
});

export default itemSlice.reducer;

export const { selectAll: selectItems, selectById: selectItem } =
  itemEntityAdapter.getSelectors(
    (state: { item: EntityState<ItemDTO, string> }) => state.item,
  );
